<template>
   <div class="shift-report-content">
      <v-row v-if="!pageData.isLoading" align="center">
         <v-col cols="12" class="">
            <v-btn color="secondary" x-small class="d-block mt-3 mi-start-auto" @click="exportPDF" outlined icon fab>
               <v-icon>mdi-printer-outline</v-icon>
            </v-btn>
         </v-col>

         <template v-if="printTemplateType === 'temp_1'">
            <v-col cols="3" class="subtitle-2 text-center gray5--text">
               {{ $t('start date') }} :<span class="gray8--text">{{ report.start_date }}</span>
            </v-col>
            <v-col cols="3" class="subtitle-2 text-center  gray5--text">
               {{ $t('end date') }} :<span class="gray8--text">{{ report.end_date }}</span>
            </v-col>
            <v-col cols="3" class="subtitle-2 text-center  gray5--text">
               {{ $t('branch') }} :<span class="gray8--text">{{ report.branch_name }}</span>
            </v-col>
            <v-col cols="3" class="subtitle-2 text-center  gray5--text">
               {{ $t('employee') }} :<span class="gray8--text">{{ report.user_full_name }}</span>
            </v-col>
            <v-col cols="12">
               <v-divider></v-divider>
            </v-col>
            <v-col cols="12" md="8">
               <v-card class="backgroundW shadow pa-9">
                  <table class="mini_table_two">
                     <tr>
                        <th>{{ $t("") }}</th>
                        <th>{{ $t("start") }}</th>
                        <th>{{ $t("Transactions") }}</th>
                        <th>{{ $t("end") }}</th>
                        <th>{{ $t("difference") }}</th>
                     </tr>
                     <tr>
                        <td>{{ $t('cash') }}</td>
                        <td>{{ report.start_cash || 0 | nonZero }}</td>
                        <td>{{ report.total_cash || 0 | nonZero }}</td>
                        <td>{{ report.end_cash || 0 | nonZero }}</td>
                        <td>{{ report.diff_cash || 0 | nonZero }}</td>
                     </tr>
                     <tr>
                        <td>{{ $t('visa') }}</td>
                        <td>{{ 0 | nonZero }}</td>
                        <td>{{ report.total_sales_visa || 0 | nonZero }}</td>
                        <td>{{ report.end_visa || 0 | nonZero }}</td>
                        <td>{{ report.diff_visa || 0 | nonZero }}</td>
                     </tr>
                     <tr>
                        <td>{{ $t('master card') }}</td>
                        <td>{{ 0 | nonZero }}</td>
                        <td>{{ report.total_sales_master || 0 | nonZero }}</td>
                        <td>{{ report.end_master || 0 | nonZero }}</td>
                        <td>{{ report.diff_master || 0 | nonZero }}</td>
                     </tr>
                     <tr>
                        <td>{{ $t('mada') }}</td>
                        <td>{{ 0 | nonZero }}</td>
                        <td>{{ report.total_sales_mada || 0 | nonZero }}</td>
                        <td>{{ report.end_mada || 0 | nonZero }}</td>
                        <td>{{ report.diff_mada || 0 | nonZero }}</td>
                     </tr>
                     <tr>
                        <td>{{ $t('other') }}</td>
                        <td>{{ 0 | nonZero }}</td>
                        <td>{{ report.total_sales_other || 0 | nonZero }}</td>
                        <td>{{ report.end_other || 0 | nonZero }}</td>
                        <td>{{ report.diff_other || 0 | nonZero }}</td>
                     </tr>
                     <tr class="font-weight-bold">
                        <td>{{ $t('total') }}</td>
                        <td>{{ calculatedTotals.total_start | nonZero }}</td>
                        <td>{{ calculatedTotals.total_actions || 0 | nonZero }}</td>
                        <td>{{ calculatedTotals.total_end || 0 | nonZero }}</td>
                        <td>{{ calculatedTotals.total_difference || 0 | nonZero }}</td>
                     </tr>
                  </table>
               </v-card>
            </v-col>
            <v-col cols="12" md="4">
               <v-card class="backgroundW shadow pa-5">
                  <div class="summary_row d-flex justify-space-between">
                     <div>{{ $t("total sales") }}</div>
                     <div>{{ report.total_sales || 0 | nonZero }}</div>
                  </div>
                  <div class="summary_row d-flex justify-space-between">
                     <div>{{ $t("sales cash") }}</div>
                     <div>{{ report.total_sales_cash || 0 | nonZero }}</div>
                  </div>
                  <div class="summary_row d-flex justify-space-between">
                     <div>{{ $t("master card") }}</div>
                     <div>{{ report.total_sales_master || 0 | nonZero }}</div>
                  </div>
                  <div class="summary_row d-flex justify-space-between">
                     <div>{{ $t("visa") }}</div>
                     <div>{{ report.total_sales_visa || 0 | nonZero }}</div>
                  </div>
                  <div class="summary_row d-flex justify-space-between">
                     <div>{{ $t("mada") }}</div>
                     <div>{{ report.total_sales_mada || 0 | nonZero }}</div>
                  </div>
                  <div class="summary_row d-flex justify-space-between">
                     <div>{{ $t("other") }}</div>
                     <div>{{ report.total_sales_other || 0 | nonZero }}</div>
                  </div>
                  <div class="summary_row d-flex justify-space-between">
                     <div>{{ $t("notice debtor") }}</div>
                     <div>{{ report.total_nd || 0 | nonZero }}</div>
                  </div>
                  <div class="summary_row d-flex justify-space-between">
                     <div>{{ $t("notice creditor") }}</div>
                     <div>{{ report.total_nc || 0 | nonZero }}</div>
                  </div>
                  <div class="summary_row d-flex justify-space-between">
                     <div>{{ $t("expenses") }}</div>
                     <div>{{ report.total_expenses || 0 | nonZero }}</div>
                  </div>
                  <div class="summary_row d-flex justify-space-between">
                     <div>{{ $t("difference cash") }}</div>
                     <div>{{ report.diff_cash || 0 | nonZero }}</div>
                  </div>
                  <div class="summary_row d-flex justify-space-between">
                     <div>{{ $t("difference network") }}</div>
                     <div>{{ calculatedTotals.total_network || 0 | nonZero }}</div>
                  </div>
               </v-card>
            </v-col>
         </template>

         <v-col v-else cols="12" class="receipt-preview-col">
            <div class="receipt-preview-wrap">
               <component
                  :is="printTemplateComponent"
                  :report="report"
                  :print-static-data="printStaticData"
               />
            </div>
         </v-col>
      </v-row>

      <v-col cols="auto" class="my-16" v-if="pageData.isLoading">
         <v-progress-circular :size="70" :width="5" style="margin: auto" class="d-block" color="primary" indeterminate>
         </v-progress-circular>
         <p class="text-center">{{ $t("please wait") }}</p>
      </v-col>

      <div>
         <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="true"
            :paginate-elements-by-height="$store.state.Settings.windowSize.x" :filename="pageData.entityName"
            :pdf-quality="2" :manual-pagination="true" pdf-format="a4" pdf-orientation="portrait"
            :pdf-content-width="$store.state.Settings.windowSize.y" ref="html2Pdf">
            <section slot="pdf-content" :dir="$vuetify.rtl ? 'rtl' : 'ltr'">
               <PrintPDF :header="[]" :maxPDFRows="20" :data="[{}]" :header_slot="printTemplateType === 'temp_2'" :content_slot="true"
                  :footer_slot="false" :showGroupHeader="false" :groupHeader="false" :footerData="[]"
                  :printStaticData="printStaticData" :branch_image_only="printTemplateType === 'temp_2'">
                  <template v-slot:pdf_content>
                     <component
                        :is="printTemplateComponent"
                        :report="report"
                        :print-static-data="printStaticData"
                     />
                  </template>
               </PrintPDF>
            </section>
         </vue-html2pdf>
      </div>
   </div>
</template>

<script>
import PrintPDF from "@/components/PrintPDF.vue";
import VueHtml2pdf from 'vue-html2pdf';
import ShiftsPrintTemp1 from "./ShiftsPrintTemp1.vue";
import ShiftsPrintTemp2 from "./ShiftsPrintTemp2.vue";

const PRINT_TEMPLATES = {
   temp_1: "ShiftsPrintTemp1",
   temp_2: "ShiftsPrintTemp2",
};

export default {
   name: "ShiftsContent",
   components: {
      PrintPDF,
      VueHtml2pdf,
      ShiftsPrintTemp1,
      ShiftsPrintTemp2,
   },
   props: {
      report: {
         type: Object,
         default: () => ({})
      },
      printStaticData: {
         type: Object,
         default: () => ({})
      },
      pageData: {
         type: Object,
         required: true
      },
      printTemplateType: {
         type: String,
         default: "temp_1"
      }
   },
   computed: {
      printTemplateComponent() {
         return PRINT_TEMPLATES[this.printTemplateType] || PRINT_TEMPLATES.temp_1;
      },
      calculatedTotals() {
         if (this.report && Object.keys(this.report).length) {
            const total_start = this.report.start_cash || 0;
            const total_actions = (this.report.total_sales_master || 0) + (this.report.total_sales_visa || 0) + (this.report.total_sales_mada || 0) + (this.report.total_sales_other || 0);
            const total_end = (this.report.end_cash || 0) + (this.report.end_visa || 0) + (this.report.end_master || 0) + (this.report.end_mada || 0) + (this.report.end_other || 0);
            const total_difference = (this.report.diff_cash || 0) + (this.report.diff_visa || 0) + (this.report.diff_master || 0) + (this.report.diff_mada || 0) + (this.report.diff_other || 0);
            const total_network = (this.report.diff_visa || 0) + (this.report.diff_master || 0) + (this.report.diff_mada || 0) + (this.report.diff_other || 0);
            return {
               total_start,
               total_actions,
               total_end,
               total_difference,
               total_network,
            };
         }
         return {
            total_start: 0,
            total_actions: 0,
            total_end: 0,
            total_difference: 0,
            total_network: 0,
         };
      }
   },
   methods: {
      exportPDF() {
         this.$refs.html2Pdf.generatePdf();
      }
   }
};
</script>

<style lang="scss" scoped>
.summary_row {
   padding: 0.4rem 0.2rem;
   border-bottom: 2px solid #eee;
   font-size: 12px !important;
   display: flex !important;
   justify-content: space-between !important;
}

td {
   padding: 1.2rem 0.4rem;
   font-size: 12px !important;
}

td:nth-of-type(1),
td:nth-of-type(4) {
   color: var(--gray7) !important;
}

#print_title {
   width: fit-content;
   text-align: center;
   font-size: 12px !important;
   color: var(--blue1);
   background: var(--blue12);
   display: block;
   padding: 1.2rem;
   margin: 30px auto;
}

.mini_table_two {
   width: 100%;
   border-collapse: collapse !important;

   tr {
      border: 1px solid #f7f9fb !important;

      th {
         text-transform: capitalize;
      }

      td,
      th {
         border: 1px solid #eee !important;
         background: #fff !important;
         height: 34.5px !important;
         font-size: 12px !important;
         padding: 12px;
      }

      td {
         background-color: #f5f6fa;
      }

      &:nth-of-type(odd) {
         td,
         th {
            background: #f7f9fb !important;
         }
      }
   }
}

.receipt-preview-col {
   display: flex;
   justify-content: center;
}
.receipt-preview-wrap {
   background: #fff;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
   padding: 16px;
   border-radius: 4px;
}
</style>
